import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import * as Yup from "yup";
import { Form, Formik, FormikHelpers } from "formik";
import { showToast } from "src/utils/showToaster";
import SocialMediaForm from "../Layout/SocialMediaForm";
import { SocialMediaFormValues } from "src/models/SocialMedia.model";
import {
  useGetCMSByTypeQuery,
  useUpdateCMSMutation,
} from "src/services/CMSService";

type Props = {
  onClose: () => void;
};

const EditSocilMediaWrapper = ({ onClose }: Props) => {
  const [items, setItems] = useState<any>({});

  const {
    data,
    isLoading,
    isFetching,
  }: // refetch,
  any = useGetCMSByTypeQuery("SOCIALMEDIA");
  const [updateSocialMedia] = useUpdateCMSMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: SocialMediaFormValues = {
    content: items?.length
      ? items.map((c: any) => ({
          name: c.name || "",
          icon: c.icon || "",
          link: c.link || "",
        }))
      : [
          {
            name: "",
            icon: "",
            link: "",
          },
        ],
  };

  const validationSchema = Yup.object().shape({
    content: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Please enter name"),
        icon: Yup.mixed<File>().required("Please upload icon"),
        link: Yup.string()
          .url("Please enter a valid URL")
          .required("Please enter link"),
      })
    ),
  });

  const handleSubmit = (
    values: SocialMediaFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SocialMediaFormValues>
  ) => {
    const payload = {
      content: values.content.map((c) => ({
        name: c.name,
        icon: c?.icon,
        link: c.link,
      })),
    };

    updateSocialMedia({ type: "SOCIALMEDIA", body: payload })
      .unwrap()
      .then((res) => {
        showToast("success", res?.data?.message);
        onClose();
        // refetch()
        setSubmitting(false);
        resetForm();
      })
      .catch((err) => {
        console.error("Failed to update Contact Info: ", err);
        showToast(
          err?.data?.message ||
            "Failed to update Contact Info. Please try again.",
          "error"
        );
        setSubmitting(false);
      });
  };
  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <SocialMediaForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditSocilMediaWrapper;
